import { render, staticRenderFns } from "./optTechnical.vue?vue&type=template&id=1c2d6e94&scoped=true"
import script from "./optTechnical.vue?vue&type=script&lang=js"
export * from "./optTechnical.vue?vue&type=script&lang=js"
import style0 from "./optTechnical.vue?vue&type=style&index=0&id=1c2d6e94&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d6e94",
  null
  
)

export default component.exports